import { TEXT_GRADE_MAP } from './config';

export function getReviewA11yLabel(rating: number, customerShortName?: string): string {
  return `Trusted Shops Bewertung: ${rating} von 5 Sternen${customerShortName ? ` von ${customerShortName}` : ''}`;
}

export function getTextGrade(rating: number): string {
  return TEXT_GRADE_MAP[Math.round(rating)] ?? '';
}
